// extracted by mini-css-extract-plugin
export default {"container":"PremiumToUltimatePaywall_container__xxKFZ"};